import { render, staticRenderFns } from "./NotificationSidebar.vue?vue&type=template&id=50295bc2&scoped=true"
import script from "./NotificationSidebar.vue?vue&type=script&lang=js"
export * from "./NotificationSidebar.vue?vue&type=script&lang=js"
import style0 from "./NotificationSidebar.vue?vue&type=style&index=0&id=50295bc2&prod&lang=scss"
import style1 from "./NotificationSidebar.vue?vue&type=style&index=1&id=50295bc2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50295bc2",
  null
  
)

export default component.exports